/**
 * Pieces of text: heading, paragraph (with a tone), code.
 */
import type { JSX } from "solid-js";
import type { UiTone } from "@protocol/UiTone";

/** A section title. */
export function UiHeading(props: { text: string }): JSX.Element {
  return (
    <h3 class="ui-heading" data-ui="heading">
      {props.text}
    </h3>
  );
}

/** A paragraph, coloured by its tone. */
export function UiText(props: { text: string; tone: UiTone }): JSX.Element {
  return (
    <p class="ui-text small" classList={{ muted: props.tone === "muted", good: props.tone === "good", warn: props.tone === "warning", err: props.tone === "bad" }} data-ui="text" data-tone={props.tone}>
      {props.text}
    </p>
  );
}

/** Text in a fixed-width font, kept as written. */
export function UiCode(props: { text: string }): JSX.Element {
  return (
    <pre class="ui-code mono" data-ui="code">
      {props.text}
    </pre>
  );
}
